import { IRootState } from '../../../../store'
import { IRespiratoryState } from '../store/respiratory.types'

export const getRespiratorySelector = (state: IRootState): IRespiratoryState => state.respiratory
